import { ImageWithFallback } from "@/components/ui/image-with-fallback";
import { Separator } from "@/components/ui/separator";
import { safeJsonParse } from "@/lib/safeJsonParse";
import { cn } from "@/lib/utils";
import EventList from "./event-list";
import { OrganizationLinks } from "./organization-link";
import Editor from "./read-only-editor";
import { Umami } from "./umami";
import dynamic from "next/dynamic";

const AdditionalCss = dynamic(() => import("@/components/ui/additional-css"), {
  ssr: false,
});

export default function OrganizationContainer({
  organization,
  includeImage,
  className,
}: any) {
  return (
    <div
      className={"flex flex-wrap w-full space-y-5 p-4"}
      id="custom-organization-wrapper"
    >
      <div className="flex flex-col items-center w-full">
        <div
          className={cn(
            "w-full p-2 mt-5 flex justify-center flex-col items-center",
            className,
          )}
          id="custom-organization-header"
        >
          <Umami umamiWebsiteId={organization?.umamiSettings.umamiWebsite} />

          <AdditionalCss payload={organization?.AdditionalCss} />

          <ImageWithFallback
            id="custom-organization-image"
            src={organization?.image}
            alt={organization?.name}
            className="w-32 h-32 rounded-full"
          />
          <h1 className="text-3xl font-semibold leading-tight tracking-tighter">
            {organization?.name}
          </h1>

          <OrganizationLinks organization={organization} />

          {organization?.description?.toString()?.length > 50 ? (
            <div
              className="w-full mt-5 leading-7 [&:not(:first-child)]:mt-6 text-justify"
              id="custom-organization-description"
            >
              <Editor value={safeJsonParse(organization.description)} />
            </div>
          ) : (
            <></>
          )}
          <Separator
            className="mt-5 mb-1 opacity-50"
            id="custom-organization-separator"
          />
          <EventList
            events={organization?.events?.reverse()}
            enableDateFiltering={true}
            className="max-w-xl"
          />
        </div>
      </div>
    </div>
  );
}
